
import { useInformation } from "@/store/store";

export default {
  setup(){
    const {getInformation, setMessage } = useInformation();

    const beat = () => {
      setMessage("Don't beat me.")
    }

    return {
      message: getInformation,
      beat,
    }
  }
}
